import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { BarData } from "../../charts/bar-chart/bar-chart.component";
import { MODEL_COLOURS } from "../../model-services/model-item-enums";
import { OrganisationService } from "../../organisation/organisation.service";
import { DEFAULT_CURRENCY, Organisation } from "../../common/organisation";
import { AnalysisScope } from "../../analysis/scope";

export class InsightsRow {
    constructor(public _key:string, public name:string, public tooltip:string, public before:number, public currency=false, public percentage?:number, public units?:string, public after?:number) {}

    get comparePercentage() {
        if (this.before === 0 && this.after === 0) return 0

        if (this.after === 0 || this.before === 0) return undefined

        return Math.round(100*((this.after-this.before)/this.before))
    }

    get compareColour() {
        if (this.before < this.after) return MODEL_COLOURS.GREEN
        if (this.before > this.after) return MODEL_COLOURS.RED
        return MODEL_COLOURS.ORANGE
    }
}

@Component({
    selector: 'app-top-five',
    templateUrl: './top-five.html',
    styleUrls: ['./top-five.css'],
    standalone: false
})
export class TopFiveComponent implements OnChanges {
    @Input() showAsTable:boolean
    @Input() title:string
    @Input() subTitle:string
    @Input() rows:InsightsRow[]
    @Input() colour:string
    @Input() icon:string
    @Input() includePercentages:boolean
    @Input() includeUnits:boolean
    @Input() includeComparison:boolean
    @Input() trigger:any

    @Input() before:string
    @Input() after:string

    // when its rows are nodes (roles, systems, actions, outputs): each gets the icon that shows its context as a graph
    @Input() contextOrganisation?:Organisation
    @Input() contextScope?:AnalysisScope

    currencyCode:string
    barData:BarData[]

    @Output() selectRowEvent = new EventEmitter<string>()

    constructor(organisationService:OrganisationService) {
        this.currencyCode = organisationService.organisation?.currencyCode||DEFAULT_CURRENCY
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ((changes['trigger'] || changes['showAsTable'] || changes['rows']) && !this.showAsTable) {
            this.barData = this.rows.map(r => {
                return new BarData(r._key, r.name, [r.before], [this.colour], [], [r.after])
            })
        }
    }

    // a row's value as a share of the largest of the five, for its bar
    share(row:InsightsRow) {
        const max = Math.max(0, ...(this.rows || []).map(r => Math.abs(r.before || 0)))
        return max ? Math.round(100 * Math.abs(row.before || 0) / max) : 0
    }

    // room for each bar, so a short list isn't stretched and a long one isn't squeezed
    chartHeight() {
        return Math.max(160, (this.rows?.length || 0) * 34 + 60)
    }

    selectRow(row:InsightsRow) {
        this.selectRowEvent.emit(row._key)
    }

    selectChart(key:string) {
        this.selectRow(this.rows.find(r => r._key === key))
    }
}